export const PrivilegeInfo = ({ isPrivileged, privilegedFee }) => {
  if (!isPrivileged || !privilegedFee || privilegedFee == 0) return null;
  return (
    <span className={`text-green`}>
      🎉 You got {isPrivileged?.collectionName}, here is your service fee: {privilegedFee}%.
    </span>
  );
};
